module.exports = __webpack_public_path__ + "static/media/Teil_1.46527bef.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_1.ogv
// module id = 117
// module chunks = 0